import { lovelaceToAda, formatAda } from '@src/utils/dRepUtils';
import LandingPageDrepCard from '../cards/LandingPageDrepCard';
import { useGetMintedDRepMetadataQuery } from '@src/store/drep/api';

// Six cards fill the strip, and the cover art below is numbered 1-6.
const FEATURED_COUNT = 6;

export default function Dreps() {
  // Over-fetched, then sliced. `/drep/accounts` is built by grouping minted
  // tokens by DRep, so every record should carry one, but the filter below is
  // what guarantees a usable href and it can shorten the row. The endpoint
  // slices an in-memory cache, so the wider limit costs no upstream call.
  const { data: dReps } = useGetMintedDRepMetadataQuery(FEATURED_COUNT * 2);

  // A record with no minted token has no profile URL to link to, and the card
  // is now an anchor, so linking it would emit `href="/"` six times.
  const featured = (dReps || [])
    .filter((drep) => Boolean(drep.tokenNames?.[0]))
    .slice(0, FEATURED_COUNT);

  return (
    <section
      aria-labelledby="featured-dreps-heading"
      className="flex w-full justify-center overflow-x-clip max-sm:justify-start"
    >
      {/* Visually hidden: the design places this strip directly under the
          banner with no room for a title, but the cards below it were a group
          of links with no heading of any kind. */}
      <h2 id="featured-dreps-heading" className="sr-only">
        Featured Cardano DReps
      </h2>
      {featured.map((drep, index) => (
        <LandingPageDrepCard
          key={drep.tokenNames[0]}
          name={drep.givenName}
          dRepHandle={drep.tokenNames[0]}
          votingPower={formatAda(lovelaceToAda(drep.activeVotingPower || 0))}
          coverPhoto={`/dReps/dRep-cover-${index + 1}.png`}
          profilePhoto={drep.image || '/dReps/default-dRep-profile.png'}
        />
      ))}
    </section>
  );
}
